'use client'
import { useState } from 'react'
import { Accordion, AccordionTab } from "primereact/accordion"
import { LuCirclePlus, LuCircleMinus } from "react-icons/lu";

export const ProductFeature = ({ data }) => {
    const [activeIndex, setActiveIndex] = useState(0)
    const isActive = activeIndex === 0

    return (
        <>
            {data && data?.length > 0 &&
                <Accordion className='accodion-root' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <AccordionTab
                        header={
                            <span className="flex align-items-center justify-content-between gap-2 w-full cursor-pointer">
                                <span className="font-bold white-space-nowrap" style={{ color: 'var(--primary-color)' }}>Product Feature</span>
                                {isActive
                                    ? <LuCircleMinus className='text-xl' style={{ color: 'var(--secondary-color)', flexShrink: 0 }} />
                                    : <LuCirclePlus className='text-xl' style={{ color: 'var(--secondary-color)', flexShrink: 0 }} />
                                }
                            </span>
                        }
                    >
                        <div className='grid m-0' style={{ gap: '0.5rem 0' }}>
                            {data?.map((text, i) => (
                                <div key={i} className='col-12 md:col-6 flex align-items-start gap-2 py-2' style={{ borderBottom: '1px solid var(--surface-border)' }}>
                                    <div style={{
                                        width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                                        background: 'rgba(27,184,167,0.1)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        marginTop: 2,
                                    }}>
                                        <i
                                            className="pi pi-check"
                                            style={{ color: 'var(--primary-color)', fontSize: '0.6rem' }}
                                        />
                                    </div>
                                    <span
                                        style={{ color: 'var(--primary-color)', fontSize: '0.82rem', lineHeight: 1.6 }}
                                        dangerouslySetInnerHTML={{ __html: text }}
                                    />
                                </div>
                            ))}
                        </div>
                    </AccordionTab>
                </Accordion>}
        </>
    )
}
